import React from "react";

import styles from "../Sidebar.module.css";

import { SidebarShortcutMedium } from "../SidebarShortcuts";

// Icons
import { WrenchIcon, TagIcon } from "@heroicons/react/24/outline";

const ProfileSlideOutPanel = () => {
  return (
    <>
      <div
        className={`flex flex-col h-full w-full pt-3 p-2 overflow-y-scroll ${styles["hide-scrollbar"]} Xbg-blue-500`}
      >
        <SidebarShortcutMedium
          shortcutText={"Profile Details"}
          Icon={WrenchIcon}
          pageLink="/profile"
        />
        <SidebarShortcutMedium
          shortcutText={"Tags"}
          Icon={TagIcon}
          pageLink="/profile_tags"
        />
      </div>
    </>
  );
};

export default ProfileSlideOutPanel;
